'use strict'
{ windowLoaded } = require('@grpn/document-states')
PageTracking = require '../../../modules/page/frontend/helpers/tracking'
{ enableShellLayout } = require('./helpers/enable_shelllayout')
{ setShellEventOrRun } = require('@grpn/shell-page')

module.exports =
  initialize: (@config) ->
    @_addListeners()

  onReady: ->
    document.body.classList.remove('no-js')
    document.body.classList.add('pull-app-is-ready')

  onLoad: ->
    enableShellLayout()
    new PageTracking().pageReady()
    document.body.classList.add('pull-app-is-loaded')

  _addListeners: ->
    domReady = (callback) ->
      if document.readyState is 'complete' or document.readyState is 'interactive'
        callback()
      else
        document.addEventListener 'DOMContentLoaded', callback

    domReady(@onReady.bind(this))
    setShellEventOrRun(=> windowLoaded.then(@onLoad))
